import React from 'react'
import makeLoadable from 'rmw-shell/lib/containers/MyLoadable'
import RestrictedRoute from 'rmw-shell/lib/containers/RestrictedRoute'
import ClientRoute from '../../src/containers/ClientRoute'
import { Redirect } from 'react-router'

const MyLoadable = (opts, preloadComponents) =>
  makeLoadable(
    { ...opts, firebase: () => import('./firebase') },
    preloadComponents
  )

const AsyncSearch = MyLoadable({ loader: () => import('../pages/Search') })
const AsyncAbout = MyLoadable({ loader: () => import('../pages/About') })
const AsyncStock = MyLoadable({ loader: () => import('../pages/Stock') })
const AsyncBillingReport = MyLoadable({
  loader: () => import('../pages/BillingReport'),
})
const AsyncChargeReport = MyLoadable({
  loader: () => import('../pages/ChargeReport'),
})

const AsyncClient = MyLoadable({
  loader: () => import('../pages/Clients/Client'),
})
const AsyncClients = MyLoadable(
  { loader: () => import('../pages/Clients/Clients') },
  [AsyncClient]
)

const AsyncUserClients = MyLoadable({
  loader: () => import('../pages/UserClients/UserClients'),
})

const AsyncWarehouse = MyLoadable({
  loader: () => import('../pages/Warehouses/Warehouse'),
})
const AsyncWarehouses = MyLoadable(
  { loader: () => import('../pages/Warehouses/Warehouses') },
  [AsyncWarehouse]
)

const AsyncDocumentType = MyLoadable({
  loader: () => import('../pages/DocumentTypes/DocumentType'),
})
const AsyncDocumentTypes = MyLoadable(
  { loader: () => import('../pages/DocumentTypes/DocumentTypes') },
  [AsyncDocumentType]
)

const AsyncUnit = MyLoadable({ loader: () => import('../pages/Units/Unit') })
const AsyncUnits = MyLoadable(
  { loader: () => import('../pages/Units/Units') },
  [AsyncUnit]
)

const AsyncWarehousePrice = MyLoadable({
  loader: () => import('../pages/WarehousePrices/WarehousePrice'),
})
const AsyncMovementPrice = MyLoadable({
  loader: () => import('../pages/MovementPrice/MovementPrice'),
})

const AsyncTruck = MyLoadable({ loader: () => import('../pages/Trucks/Truck') })
const AsyncTrucks = MyLoadable(
  { loader: () => import('../pages/Trucks/Trucks') },
  [AsyncTruck]
)

const AsyncTrailer = MyLoadable({
  loader: () => import('../pages/Trailers/Trailer'),
})
const AsyncTrailers = MyLoadable(
  { loader: () => import('../pages/Trailers/Trailers') },
  [AsyncTrailer]
)

const AsyncDriver = MyLoadable({
  loader: () => import('../pages/Drivers/Driver'),
})
const AsyncDrivers = MyLoadable(
  { loader: () => import('../pages/Drivers/Drivers') },
  [AsyncDriver]
)

const AsyncItem = MyLoadable({ loader: () => import('../pages/Items/Item') })
const AsyncItems = MyLoadable(
  { loader: () => import('../pages/Items/Items') },
  [AsyncItem]
)

const AsyncTaskType = MyLoadable({
  loader: () => import('../pages/TaskTypes/TaskType'),
})
const AsyncTaskTypes = MyLoadable(
  { loader: () => import('../pages/TaskTypes/TaskTypes') },
  [AsyncTaskType]
)

const AsyncWarehouseTaskWorkflow = MyLoadable({
  loader: () => import('../pages/WarehouseTaskWorkflows/WarehouseTaskWorkflow'),
})
const AsyncWarehouseTaskWorkflows = MyLoadable(
  {
    loader: () =>
      import('../pages/WarehouseTaskWorkflows/WarehouseTaskWorkflows'),
  },
  [AsyncWarehouseTaskWorkflow]
)

const AsyncWarehouseTask = MyLoadable({
  loader: () => import('../pages/WarehouseTasks/WarehouseTask'),
})
const AsyncWarehouseTasks = MyLoadable(
  { loader: () => import('../pages/WarehouseTasks/WarehouseTasks') },
  [AsyncWarehouseTask]
)

const AsyncWarehouseTaskMovement = MyLoadable({
  loader: () => import('../pages/WarehouseTaskMovements/WarehouseTaskMovement'),
})

const AsyncWTMCreate = MyLoadable({
  loader: () => import('../pages/WarehouseTaskMovements/WTMCreate'),
})

/*
const AsyncWarehouseTaskMovementContent = MyLoadable({
  loader: () =>
    import(
      '../pages/WarehouseTaskMovementContents/WarehouseTaskMovementContent'
    ),
})
*/

const AsyncWarehouseTaskFile = MyLoadable({
  loader: () => import('../pages/WarehouseTaskFiles/WarehouseTaskFile'),
})

const routes = [
  /* eslint-disable react/jsx-key */

  <RestrictedRoute type="private" path="/" exact>
    <Redirect to="/warehouse_tasks/0" />
  </RestrictedRoute>,
  <RestrictedRoute type="private" path="/dashboard" exact>
    <Redirect to="/warehouse_tasks/0" />
  </RestrictedRoute>,
  <ClientRoute
    type="private"
    path="/search/:clientId"
    exact
    component={AsyncSearch}
  />,
  <RestrictedRoute type="private" path="/about" exact component={AsyncAbout} />,

  <RestrictedRoute
    type="private"
    path="/select_client"
    exact
    component={AsyncUserClients}
  />,

  <RestrictedRoute
    type="private"
    path="/clients"
    exact
    component={AsyncClients}
  />,
  <RestrictedRoute
    type="private"
    path="/clients/create"
    exact
    component={AsyncClient}
  />,
  <RestrictedRoute
    type="private"
    path="/clients/create/:editType"
    exact
    component={AsyncClient}
  />,
  <RestrictedRoute
    type="private"
    path="/clients/edit/:uid/:editType"
    exact
    component={AsyncClient}
  />,

  <RestrictedRoute
    type="private"
    path="/warehouses"
    exact
    component={AsyncWarehouses}
  />,
  <RestrictedRoute
    type="private"
    path="/warehouses/create"
    exact
    component={AsyncWarehouse}
  />,
  <RestrictedRoute
    type="private"
    path="/warehouses/edit/:uid"
    exact
    component={AsyncWarehouse}
  />,

  <RestrictedRoute
    type="private"
    path="/document_types"
    exact
    component={AsyncDocumentTypes}
  />,
  <RestrictedRoute
    type="private"
    path="/document_types/create"
    exact
    component={AsyncDocumentType}
  />,
  <RestrictedRoute
    type="private"
    path="/document_types/edit/:uid"
    exact
    component={AsyncDocumentType}
  />,

  <RestrictedRoute type="private" path="/units" exact component={AsyncUnits} />,
  <RestrictedRoute
    type="private"
    path="/units/create"
    exact
    component={AsyncUnit}
  />,
  <RestrictedRoute
    type="private"
    path="/units/edit/:uid"
    exact
    component={AsyncUnit}
  />,

  //***START client related routes***

  <ClientRoute
    type="private"
    path="/trucks/:clientId"
    exact
    component={AsyncTrucks}
  />,
  <ClientRoute
    type="private"
    path="/trucks/:clientId/create"
    exact
    component={AsyncTruck}
  />,
  <ClientRoute
    type="private"
    path="/trucks/:clientId/edit/:uid"
    exact
    component={AsyncTruck}
  />,

  <ClientRoute
    type="private"
    path="/warehouse_prices/:clientId/edit/:uid/:editType"
    exact
    component={AsyncWarehousePrice}
  />,
  <ClientRoute
    type="private"
    path="/movement_prices/:clientId/:warehouseUid/edit/:uid"
    exact
    component={AsyncMovementPrice}
  />,

  <ClientRoute
    type="private"
    path="/trailers/:clientId"
    exact
    component={AsyncTrailers}
  />,
  <ClientRoute
    type="private"
    path="/trailers/:clientId/create"
    exact
    component={AsyncTrailer}
  />,
  <ClientRoute
    type="private"
    path="/trailers/:clientId/edit/:uid"
    exact
    component={AsyncTrailer}
  />,

  <ClientRoute
    type="private"
    path="/drivers/:clientId"
    exact
    component={AsyncDrivers}
  />,
  <ClientRoute
    type="private"
    path="/drivers/:clientId/create"
    exact
    component={AsyncDriver}
  />,
  <ClientRoute
    type="private"
    path="/drivers/:clientId/edit/:uid"
    exact
    component={AsyncDriver}
  />,

  <ClientRoute
    type="private"
    path="/items/:clientId"
    exact
    component={AsyncItems}
  />,
  <ClientRoute
    type="private"
    path="/items/:clientId/create"
    exact
    component={AsyncItem}
  />,
  <ClientRoute
    type="private"
    path="/items/:clientId/edit/:uid"
    exact
    component={AsyncItem}
  />,

  <ClientRoute
    type="private"
    path="/task_types/:clientId"
    exact
    component={AsyncTaskTypes}
  />,
  <ClientRoute
    type="private"
    path="/task_types/:clientId/create"
    exact
    component={AsyncTaskType}
  />,
  <ClientRoute
    type="private"
    path="/task_types/:clientId/edit/:uid"
    exact
    component={AsyncTaskType}
  />,

  <ClientRoute
    type="private"
    path="/stock/:clientId"
    exact
    component={AsyncStock}
  />,
  <ClientRoute
    type="private"
    path="/billing_report/:clientId"
    exact
    component={AsyncBillingReport}
  />,
  <ClientRoute
    type="private"
    path="/charge_report/:clientId"
    exact
    component={AsyncChargeReport}
  />,

  <ClientRoute
    type="private"
    path="/warehouse_task_workflows/:clientId"
    exact
    component={AsyncWarehouseTaskWorkflows}
  />,
  <ClientRoute
    type="private"
    path="/warehouse_task_workflows/:clientId/create/:editType"
    exact
    component={AsyncWarehouseTaskWorkflow}
  />,
  <ClientRoute
    type="private"
    path="/warehouse_task_workflows/:clientId/edit/:uid/:editType"
    exact
    component={AsyncWarehouseTaskWorkflow}
  />,

  <ClientRoute
    type="private"
    path="/warehouse_tasks/:clientId"
    exact
    component={AsyncWarehouseTasks}
  />,
  <ClientRoute
    type="private"
    path="/warehouse_tasks/:clientId/create/:editType"
    exact
    component={AsyncWarehouseTask}
  />,
  <ClientRoute
    type="private"
    path="/warehouse_tasks/:clientId/edit/:uid/:editType"
    exact
    component={AsyncWarehouseTask}
  />,

  <ClientRoute
    type="private"
    path="/warehouse_task_movements/:clientId/:taskUid/create"
    exact
    component={AsyncWTMCreate}
  />,

  <ClientRoute
    type="private"
    path="/warehouse_task_movements/:clientId/:taskUid/edit/:uid"
    exact
    component={AsyncWarehouseTaskMovement}
  />,

  /*
  <ClientRoute
    type="private"
    path="/warehouse_task_movement_contents/:clientId/:taskUid/:movementUid/create"
    exact
    component={AsyncWarehouseTaskMovementContent}
  />,
  <ClientRoute
    type="private"
    path="/warehouse_task_movement_contents/:clientId/:taskUid/:movementUid/edit/:uid"
    exact
    component={AsyncWarehouseTaskMovementContent}
  />,
  */

  <ClientRoute
    type="private"
    path="/warehouse_task_files/:clientId/:taskUid/create"
    exact
    component={AsyncWarehouseTaskFile}
  />,
  <ClientRoute
    type="private"
    path="/warehouse_task_files/:clientId/:taskUid/edit/:uid"
    exact
    component={AsyncWarehouseTaskFile}
  />,

  //***END client related routes***

  /* eslint-enable react/jsx-key */
]

export default routes
